/**
     * RoamerScoreUpdated.contract.ts — Event Contract System™ (generation v1).
     * Roamer Score recomputed for the new base (observability — the Local card recomputes via useRoamerLocation on the same trigger).
     */

    import type { EventContract } from '../EventContractRegistry';

    export const RoamerScoreUpdatedContract: EventContract = {
      name: 'RoamerScoreUpdated',
      version: 1,
      description: "Roamer Score recomputed for the new base (observability — the Local card recomputes via useRoamerLocation on the same trigger).",
      publishers: ["core"],
      subscribers: ["dev-center:live-feed"],
      fields: [
        { name: 'locationId', type: 'string', required: true, description: "The base the score was recomputed for" },
      ],
      allowExtraFields: false,
      timestampPolicy: "Workflow time (now) inside runLocationChangedWorkflow.",
      stability: 'observability',
      deprecated: false,
      example: {"locationId":"lisbon"},
    };
    